import { VscDebugBreakpointFunction } from "react-icons/vsc";
export const skills = [
  {
    id: 1,
    label: "frontend",
    icon: <VscDebugBreakpointFunction />,
    value: "",
  },
  {
    id: 2,
    label: "backend",
    icon: <VscDebugBreakpointFunction />,
    value: "",
  },
  {
    id: 3,
    value: "",
    label: "database",
    icon: <VscDebugBreakpointFunction />,
  },
  {
    id: 4,
    value: "",
    label: "design",
    icon: <VscDebugBreakpointFunction />,
  },
];
